<template>
  <section class="relative overflow-hidden pt-[114px] pb-[114px] mb-12 md:mb-20">
    <SectionWaves />
    <div class="relative z-10 bg-gray-100 py-12 md:py-16">
      <div class="container mx-auto max-w-[900px] px-4">
      <h3 class="landing_h2 mb-8 md:mb-14 text-center">
        <Translate translate-key="landing_legality_seller.title" />
      </h3>
      <ul
        class="grid list-none gap-8 p-0 md:grid-cols-3 md:gap-6 prose prose-gray prose-sm max-w-none prose-p:mb-2 prose-p:text-left text-sm"
      >
        <li
          v-for="(item, i) in legalityItems"
          :key="i"
          class="rounded-xl bg-white p-6 text-center shadow-sm md:p-8"
        >
          <NuxtImg
            :src="item.img"
            :alt="t(item.altKey)"
            :width="item.width"
            height="77"
            format="webp"
            loading="lazy"
            class="mx-auto mb-4 h-[77px] w-auto object-contain"
          />
          <div class="text-left [&_strong]:font-semibold" v-html="t(item.textKey)" />
        </li>
      </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import SectionWaves from "~/features/landing-page/components/sections/SectionWaves.vue";
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const legalityItems = [
  {
    img: "/landing/au-tradelines-are-safe-and-legal.png",
    width: 103,
    altKey: "landing_legality_seller.image_1_alt",
    textKey: "landing_legality_seller.text_1",
  },
  {
    img: "/landing/safety.png",
    width: 86,
    altKey: "landing_legality_seller.image_2_alt",
    textKey: "landing_legality_seller.text_2",
  },
  {
    img: "/landing/modern-security.png",
    width: 129,
    altKey: "landing_legality_seller.image_3_alt",
    textKey: "landing_legality_seller.text_3",
  },
];
</script>
